/**
 * Web-Logout setzt das, bevor signOut läuft. Sync und Retry rufen sonst
 * getSession auf und können das Access-Token refreshen, während der
 * Logout die Session gerade entfernt.
 */
let paused = false;
const resumed = new Set<() => void>();

export function pauseOfflineSync(): void {
  paused = true;
}

export function resumeOfflineSync(): void {
  if (!paused) return;
  paused = false;
  resumed.forEach((listener) => {
    listener();
  });
}

export function isOfflineSyncPaused(): boolean {
  return paused;
}

export function onOfflineSyncResumed(listener: () => void): () => void {
  resumed.add(listener);
  return () => {
    resumed.delete(listener);
  };
}

export function resetOfflineSyncPauseForTests(): void {
  paused = false;
  resumed.clear();
}
